import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/Modal";

import Alert from "react-bootstrap/Alert";

import { FaProjectDiagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Col, ButtonGroup } from "react-bootstrap";
import AvailableProjects from "./AvailableProjects";
import UserProjects from "./UserProjects";
import { AddUserProjectMutation, hash } from "../gql/AssignProjectMutations";
import {
  DeleteUserProjectMutation,
  hash as hash1,
} from "../gql/DeleteUserProjectsMutation";

const AssignProjects = ({ user }) => {
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState([]);
  const [selected, setSelected] = useState("");
  const [deselected, setDeselected] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const userId = user.appId;

  const [assignProject] = useMutation(AddUserProjectMutation, {
    context: { headers: { "X-Trust-Key": hash } },
  });
  const [unassignProject] = useMutation(DeleteUserProjectMutation, {
    context: { headers: { "X-Trust-Key": hash1 } },
  });

  const addProject = async () => {
    try {
      if (!selected || selected === "") {
        setErrorMessage("Please Select a Project.");
        return;
      }
      await assignProject({
        variables: { userId: userId, projectName: selected },
      });
      setSelected("");
    } catch (error) {
      setErrorMessage("There was an error assigning this project.");
    }
  };

  const deleteProject = async () => {
    try {
      if (!deselected || deselected === "") {
        setErrorMessage("Please Select a Project.");
        return;
      }
      await unassignProject({
        variables: { id: deselected },
      });
      setDeselected("");
    } catch (error) {
      setErrorMessage("There was an error unassigning this project.");
    }
  };

  return (
    <>
      <Modal
        centered
        show={show}
        backdrop
        size="lg"
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Assign Projects for {user.firstName} {user.lastName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-auto d-flex  flex-row align-items-center justify-content-center">
          <Col className="p-2 m-2">
            <AvailableProjects
              selected={selected}
              setSelected={setSelected}
              current={current}
            />
          </Col>
          <Col>
            <ButtonGroup>
              <Button
                size="sm"
                title="Unassign Project to user"
                style={{ color: "white" }}
                onClick={() => deleteProject()}
              >
                <FaArrowLeft></FaArrowLeft>
              </Button>
              <Button
                size="sm"
                title="Assign Project to user"
                style={{ color: "white" }}
                onClick={() => addProject()}
              >
                <FaArrowRight />
              </Button>
            </ButtonGroup>
          </Col>
          <Col className="p-2 m-2">
            <UserProjects
              userId={userId}
              deselected={deselected}
              setDeselected={setDeselected}
              setCurrent={setCurrent}
            />
          </Col>

          {successMessage && (
            <Alert>
              <p style={{ textAlign: "center" }}>
                Projects successfully assigned.
              </p>
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-start-end flex-row align-items-center justify-content-between">
          {errorMessage !== "" && (
            <Alert
              variant="danger"
              dismissable
              closeVariant="white"
              onClick={() => setErrorMessage("")}
              onClose={() => setErrorMessage("")}
            >
              There was a problem assigning devices to this user.
            </Alert>
          )}
          <Button
            variant="danger"
            className="ms-auto"
            style={{ color: "white" }}
            onClick={() => {
              setErrorMessage("");
              setSuccessMessage(false);
              setShow(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Button
        title="Assign Projects"
        size="sm"
        disabled={!user.isExternal}
        variant="info"
        style={{ color: "white" }}
        onClick={() => setShow(true)}
      >
        <FaProjectDiagram />
      </Button>
    </>
  );
};

export default AssignProjects;
